// Note: this list must match the list in Help Pages
const iframeDomainWhitelist = [
    'www.youtube-nocookie.com',
    'youtube.com',
    'www.youtube.com',
    'youtu.be',
    'vimeo.com',
    'www.vimeo.com',
    'player.vimeo.com',
    'facebook.com',
    'www.facebook.com',
    'instagram.com',
    'www.instagram.com',
    'js.storylane.io',
    'app.storylane.io'
];

const isIframeDomainAllowed = (src: string | null | undefined): boolean => {
    if (!src) return false;
    try {
        const url = new URL(src);
        return iframeDomainWhitelist.includes(url.hostname);
    } catch (error) {
        return false;
    }
};

export default isIframeDomainAllowed;
